import React from 'react';
import { useLoading } from '../../context/LoadingContext';
import ClockLoader from 'react-spinners/ClockLoader';

const LoadingIndicator = () => {
  const { loading } = useLoading();

  if (!loading) return null;

  return (
    <div className="spinner-container">
      <ClockLoader size={100} color={"#ffcd00"} loading={loading} />
    </div>
  );
};

export default LoadingIndicator;
